import React, { useEffect, useState } from "react";
import styles from "./NewsPage.module.scss";
import { useNavigate } from "react-router-dom";
import NewsTopHeader from "../../Molecules/TableTopHeader/NewsTopHeader";
import { useFetchNewsletters } from "../../../Hooks/Newsletters";
import NewsletterCard from "../../Molecules/NewsAndEvents/NewsletterCard";
import TablePagination from "../../Molecules/Pagination/TablePagination";
import ActivityHeader from "../../Molecules/NewsAndEvents/ActivityHeader";
import Loader from "../../Molecules/Loader/Loader";
import { isEmpty } from "lodash";
import NoDataComponent from "../../Molecules/Custom/NoDataComponent/NoDataComponent";

const NewslettersPage = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [search, setSearch] = useState("");

  const {
    data: news,
    refetch: refetchNewsletters,
    isLoading,
  } = useFetchNewsletters({
    pageSize: pageSize,
    pageNumber: page,
    selectedActivity: selectedActivity,
    searchKey: search,
  });
  const itemsPerPage = news?.data?.pageSize;
  const totalItems = news?.data?.totalCount;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handleNavigate = (e) => {
    e.preventDefault();
    navigate("/home/add-newsletters");
  };

  useEffect(() => {
    refetchNewsletters();
  }, [page, pageSize, selectedActivity, search]);

  return (
    <div>
      <NewsTopHeader
        search={search}
        setSearch={setSearch}
        handleNewClick={handleNavigate}
        type="newsletter"
      />
      <ActivityHeader
        selectedActivity={selectedActivity}
        setSelectedActivity={setSelectedActivity}
      />
      <div className={styles['table-container']}>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            {!isEmpty(news?.data?.items) ? (
              <div
                className={`${styles['major-box-grid']} ${
                  news?.data?.items?.length < 3 ? styles['smaller-grid'] : ''
                }`}
              >
                {news?.data?.items.map((newsletter) => (
                  <NewsletterCard
                    newsletter={newsletter}
                    refetchNews={refetchNewsletters}
                  />
                ))}
              </div>
            ) : (
              <NoDataComponent text="No Newsletter" />
            )}
          </>
        )}
        <TablePagination
          totalPages={totalPages}
          page={page}
          setPage={setPage}
          itemsPerPage={pageSize}
          setPageSize={setPageSize}
        />
      </div>
    </div>
  );
};

export default NewslettersPage;
